module.exports = __webpack_public_path__ + "static/media/jndpz-ever.ab099ce6.png";